export default [
  {
    path: "/pages/faq",
    name: "pages-faq",
    component: () => import("@/modules/ngo/ngo-profile/pages/FAQ/index.vue"),
    meta: {
      pageTitle: "الأسئلة الأكثر شيوعاً",
      breadcrumb: [
        // {
        //   text: "الصفحات",
        // },
        {
          text: "الأسئلة الأكثر شيوعاً",
          active: true,
        },
      ],
    },
  },
];
